import type { ClaimCandidateGroupMember, ClaimGroupValueRollup, ClaimValueBreakdown } from "@hp/types";

export interface ClaimValueParts {
  principalLow: number;
  principalHigh: number;
  carryingLow: number;
  carryingHigh: number;
}

/** Principal (RoE differential) vs LPS from breakdown, falling back to totals. */
export function claimValueParts(
  valueLow: number,
  valueHigh: number,
  breakdown?: ClaimValueBreakdown | null,
): ClaimValueParts {
  return {
    principalLow: breakdown?.principal_low ?? valueLow,
    principalHigh: breakdown?.principal_high ?? valueHigh,
    carryingLow: breakdown?.carrying_cost_low ?? 0,
    carryingHigh: breakdown?.carrying_cost_high ?? 0,
  };
}

/** Sum principal, LPS, and totals across group members (or use API rollup when present). */
export function rollupGroupValues(
  members: ClaimCandidateGroupMember[],
  apiRollup?: ClaimGroupValueRollup | null,
): ClaimGroupValueRollup {
  if (apiRollup) return apiRollup;
  let principalLow = 0;
  let principalHigh = 0;
  let carryingLow = 0;
  let carryingHigh = 0;
  let totalLow = 0;
  let totalHigh = 0;
  for (const member of members) {
    const parts = claimValueParts(member.value_low ?? 0, member.value_high ?? 0, member.value_breakdown);
    principalLow += parts.principalLow;
    principalHigh += parts.principalHigh;
    carryingLow += parts.carryingLow;
    carryingHigh += parts.carryingHigh;
    totalLow += member.value_low ?? 0;
    totalHigh += member.value_high ?? 0;
  }
  return {
    principal_low: principalLow,
    principal_high: principalHigh,
    carrying_cost_low: carryingLow,
    carrying_cost_high: carryingHigh,
    total_low: totalLow,
    total_high: totalHigh,
    member_count: members.length,
  };
}
